import { render, staticRenderFns } from "./MTNPopup.vue?vue&type=template&id=5496b748"
import script from "./MTNPopup.vue?vue&type=script&lang=js"
export * from "./MTNPopup.vue?vue&type=script&lang=js"
import style0 from "./MTNPopup.vue?vue&type=style&index=0&id=5496b748&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports